// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dma-list-container {
  height: 555px;
  overflow-y: auto;
}
.view-more-loc {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.loc-popover-title {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.dma-list-popover-content {
  width: 100% !important;
}
.dma-list-alphabetics-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10;
  overflow-y: scroll;
  min-height: 300px;
  max-height: 575px;
}
.alphabet-item {
  font-size: 13px;
  color: #8e9190;
  font-weight: 600;
}
.alphabet-list {
  width: 50px;
}

.alphabet-item {
  cursor: pointer;
  justify-content: center;
  text-align: center;
  transition: color 0.3s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.selected-alphabet {
  color: #d2042d !important;
  font-weight: bold;
  font-size: 16px;
}
.more-locations-with-count {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.more-locations-with-count-numbers {
  font-size: 12px;
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
}
.search-f-loc.ant-input-outlined:focus,
.search-f-loc.ant-input-outlined:focus-within {
  border-color: #000 !important;
}

.search-f-loc .ant-input-prefix {
  margin-right: 1rem;
}
.search-f-loc.ant-input-filled:focus,
.search-f-loc.ant-input-filled:focus-within {
  outline: 0;
  border-color: #000 !important;
  background-color: #ffffff;
}
.dma-list-location-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  white-space: nowrap;
}
.city-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow-x: auto;
  scrollbar-width: thin; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
`, "",{"version":3,"sources":["webpack://./src/components/common/dma-list/DmaList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,YAAY;AACxC","sourcesContent":[".dma-list-container {\n  height: 555px;\n  overflow-y: auto;\n}\n.view-more-loc {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.loc-popover-title {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.dma-list-popover-content {\n  width: 100% !important;\n}\n.dma-list-alphabetics-list {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 10;\n  overflow-y: scroll;\n  min-height: 300px;\n  max-height: 575px;\n}\n.alphabet-item {\n  font-size: 13px;\n  color: #8e9190;\n  font-weight: 600;\n}\n.alphabet-list {\n  width: 50px;\n}\n\n.alphabet-item {\n  cursor: pointer;\n  justify-content: center;\n  text-align: center;\n  transition: color 0.3s ease;\n  cursor: pointer;\n  user-select: none;\n}\n\n.selected-alphabet {\n  color: #d2042d !important;\n  font-weight: bold;\n  font-size: 16px;\n}\n.more-locations-with-count {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.more-locations-with-count-numbers {\n  font-size: 12px;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n}\n.search-f-loc.ant-input-outlined:focus,\n.search-f-loc.ant-input-outlined:focus-within {\n  border-color: #000 !important;\n}\n\n.search-f-loc .ant-input-prefix {\n  margin-right: 1rem;\n}\n.search-f-loc.ant-input-filled:focus,\n.search-f-loc.ant-input-filled:focus-within {\n  outline: 0;\n  border-color: #000 !important;\n  background-color: #ffffff;\n}\n.dma-list-location-name {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n.city-row {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow-x: auto;\n  scrollbar-width: thin; /* Firefox */\n  -ms-overflow-style: none; /* IE/Edge */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
